
// User "logged in" token
export const USER_TOKEN_COOKIE_NAME = 'TT_USER_TOKEN'
// Tracking "session" (visit) cookie
export const TTSVID_COOKIE_NAME = 'TTSVID'
// Long term tracking cookie
export const TTUID_NAME = 'TT_UID'
// Seller rating last seen date
export const SR_LAST_SEEN_DATE_COOKIE_NAME = 'TT_SRLSD'


// Get the value of the cookie with cName, return null if it does not exist
export function getCookie(cName: string): string {
  let value = null
  const ac = document.cookie
  let start = ac.indexOf(`${cName}=`)
  if (start >= 0) {
    start += cName.length + 1
    let end = ac.indexOf(';', start)
    if (end === -1) {
      end = ac.length
    }
    value = decodeURIComponent(ac.substring(start, end))
  }
  return value
}

export function dropCookie(cName: string): void {
  setCookie(cName)
}

export function dropAllCookies(): void {
  dropCookie(USER_TOKEN_COOKIE_NAME)
  dropCookie(TTSVID_COOKIE_NAME)
  dropCookie(TTUID_NAME)
  dropCookie(SR_LAST_SEEN_DATE_COOKIE_NAME)
}

export function dropTargetingCookies(): void {
  dropCookie(TTSVID_COOKIE_NAME)
  dropCookie(TTUID_NAME)
}

export function setCookie(cName: string, value = undefined, age: number = undefined): void {
  let dc = `${cName}=`
  if (typeof value !== 'undefined') {
    dc += `${encodeURIComponent(value)}; path=/`
    if (typeof age !== 'undefined') {
      if (age !== -1) {
        const d = new Date()
        d.setTime(d.getTime() + (age * 1000))
        dc += `; Expires=${d.toUTCString()}`
      }
    }
  } else {
    // removes the cookie
    dc += `; path=/; Expires=${new Date(0).toUTCString()}`
  }
  document.cookie = dc
}
